import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl'

import "assets/vendors/style"
import AppLocale from '../lngProvider';

import MainApp from 'app/index';
// import SignIn from './SignIn';
// import ForgotPassword from './ForgotPassword';
import { setInitUrl } from '../actions/Auth';
import { fetch_user_details } from '../actions/user';
import RTL from 'util/RTL';
import asyncComponent from 'util/asyncComponent';
import CircularProgress from "components/CircularProgress/index";

const RestrictedRoute = (props) => {
    const {
        component: Component,
        auth: {
            is_authenticated,
            is_authorized
        },
        ...rest
    } = props;

    return (
        <Route
            {...rest}
            render={props =>
                (is_authenticated && is_authorized)
                    ? <Component {...props} />
                    : <Redirect
                        to={{
                            pathname: '/signin',
                            state: { from: props.location }
                        }}
                    />}
        />
    )
};


const LazySignIn = asyncComponent(() => import('./SignIn'));
const LazyForgotPassword = asyncComponent(() => import('./ForgotPassword'));

// change redirect page sample-page to patient page
const App = (props) => {
    const {
        location,
        match,
        locale,
        initURL,
        is_authenticated,
        is_authorized,
        fetch_user_details,
    } = props;

    useEffect(() => {
        fetch_user_details();
        window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
        if (initURL === '') {
            setInitUrl(props.history.location.pathname);
        }
    }, [])

    if (is_authenticated) {
        if (is_authorized) {
            if (location.pathname === "/signin" || location.pathname === "/signup" || location.pathname === "/" || location.pathname === 'forgot_password') {
                return (<Redirect to={"/app/"} />);
            }
        } else {
            if (location.pathname === "/") {
                return (<Redirect to={"/signin"} />);
            }
            if (location.pathname !== "/" && location.pathname !== "/signin" && location.pathname !== "/signup" && location.pathname !== "/forgot_password") {
                //return ( <Redirect to={"/signin"}/> );
            }
        }
    }

    const currentAppLocale = AppLocale[locale.locale];
    // console.log(currentAppLocale)
    if (!is_authenticated) {
        return (
            <div className="loader-view d-flex align-items-center justify-content-center" style={{ height: '100%', width: '100%' }}>
                <CircularProgress />
            </div>
        );
    }
    return (
        <MuiPickersUtilsProvider utils={dayjs}>
            <IntlProvider
                locale={currentAppLocale.locale}
                messages={currentAppLocale.messages}>
                <RTL>
                    <div className="app-main">
                        <Switch>
                            {is_authenticated && is_authorized ? <RestrictedRoute path={`${match.url}app`} auth={{ is_authenticated, is_authorized }} component={MainApp} /> : null}
                            <Route exact path='/signin' component={LazySignIn} />
                            <Route exact path='/forgot_password' component={LazyForgotPassword} />
                            <Route component={asyncComponent(() => import('components/Error404'))} />
                        </Switch>
                    </div>
                </RTL>
            </IntlProvider>
        </MuiPickersUtilsProvider>
    );
}

const mapStateToProps = (state) => {
    const { settings, auth, user } = state;

    const { sideNavColor, locale, isDirectionRTL } = settings;
    const { authUser, initURL } = auth;
    const { is_authenticated, is_authorized } = user;

    return {
        sideNavColor,
        locale,
        isDirectionRTL,
        authUser,
        is_authenticated,
        is_authorized,
        initURL
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setInitUrl: (payload) => dispatch(setInitUrl(payload)),
        fetch_user_details: (payload) => dispatch(fetch_user_details(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);